


import { resourceHeaders } from './resource-actions.factory';

export default [
  '$resource',
  UserResource
];

/**
 * @typedef {object} IUserResource
 * @property {() => ng.resource.IResource<import("types/api").V1.UserFromAPI>} get
 * @property {(args: import("types/api").V2.FetchFastlinkStrategy.Request) => ng.resource.IResource<import("types/api").V2.FetchFastlinkStrategy.Response>} getFastlinkInfo
 * @property {(results: any) => ng.resource.IResource<unknown>} updateOBQAnswers
 * @property {(status: any) => ng.resource.IResource<any>} postFastlinkV3Success
 */

/**
 * @param {ng.resource.IResourceService} $resource
 */
export function UserResource($resource) {
  return $resource('/api/v1/user', {}, {
    'get': {
      method: 'GET',
      headers: resourceHeaders.get,
    },
    'getFastlinkInfo': {
      url: '/api/v1/fastlink',
      method: 'POST',
      headers: resourceHeaders.post
    },
    'updateOBQAnswers': {
      url: '/api/v1/user/obq',
      method: 'PATCH',
      headers: resourceHeaders.patch
    },
    'postFastlinkV3Success': {
      url: '/fastlink/v3/success',
      method: 'POST',
      headers: resourceHeaders.post
    },
  });
}